import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Column, Page, Paging} from './datatable.interface';
import {DatatableService} from './service/datatable.service';

@Component({
  selector: 'ui-datatable',
  template: `<div class="ui-dt-table">
  <div class="ui-dt-thead row">
    <div *ngFor="let col of columns" [ngClass]="getColumnClass(col)"  >
      {{col.label}}
      <i class="fas fa-sort-amount-up" (click)="sort(col)"></i>
    </div>
  </div>
  <div class="ui-dt-thead row">
    <div *ngFor="let col of columns" [ngClass]="getColumnClass(col)"  >
        <input type="text" class="form-control form-control-sm"
               [name]="col.field"
               [ngModel]="search[col.field]"
               (keyup)="filter($event, col.field, $event.target.value)"
        >
    </div>
  </div>
  <div class="ui-dt-tbody">
    <div *ngFor="let row of page.rows;let i=index;" class="row ui-dt-row">
      <div [attr.class]="col.className +' ui-dt-cell'" *ngFor="let col of columns;let k=index;">
         {{row[col.field]}}
      </div>
    </div>
  </div>
</div>
<ui-pagination
  [size]="size"
  [totalCount]="resultCount"
  (pageChange)="onPageChange($event)">
</ui-pagination>

`,
  styles: [`.ui-dt-thead{border-bottom:1px solid #999}.ui-dt-thead .ui-dt-cell{font-weight:500}.ui-dt-row{border-bottom:1px solid #999}.ui-dt-cell{-ms-word-break:break-word;word-break:break-word;border-left:1px solid #ddd;padding:5px}.ui-dt-row .ui-dt-cell:last-child{border-right:1px solid #ddd}`]
})
export class DatatableComponent implements OnInit {

  @Input() rows;
  @Input() columns: Column;
  @Output() pageChange = new EventEmitter();
  @Output() sorted = new EventEmitter();
  @Input() size = 6;
  page: Page;
  search: any = {};
  resultCount: number;

  constructor(private _dts: DatatableService) {
  }

  ngOnInit() {
    this.page = this._dts.getPageData(this.rows, this.size, 1);
    console.log(this.page);
    this.resultCount = this.rows.length;
  }

  getColumnClass(col: Column) {
    let className = ' ui-dt-cell ';
    if (col.className) {
      className += col.className + ' ';
    }
    if (col.sortable) {
      className += ' sortable';
    }
    return className;
  }


  onPageChange(e: Paging) {
    this.page = this._dts.getPageData(this.rows, this.size, e.pageNum);
  }

  sort(item) {
    this.page.rows.sort(this.dynamicSort(item.field));
  }

  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder === -1) {
        return b[property].toString().localeCompare(a[property]);
      } else {
        return a[property].toString().localeCompare(b[property]);
      }
    };
  }

  filter(event, field, val) {
    if (val.toString().length) {
      if (event.keyCode === 13 || event.which === 13) {
        this.search = {};
        this.search[field] = val;
        console.log(field, this.search, this.rows);
        const rows = [];
        this.rows.forEach((item) => {
          if (item[field].toString().toLowerCase().indexOf(val.toString().toLowerCase()) !== -1) {
            rows.push(item);
          }
        });
        this.resultCount = rows.length;
        this.page = this._dts.getPageData(rows, this.size, 1);
      }
    } else {
      this.resultCount = this.rows.length;
      this.page = this._dts.getPageData(this.rows, this.size, 1);
    }
  }

}
